// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import { app as firebaseApp } from './firebaseConfig';
import { getAnalytics, logEvent } from "firebase/analytics";

const app = createApp(App);

// Beispiel: Nutze analytics, um einen Seitenaufruf zu protokollieren
const analytics = getAnalytics(firebaseApp);
logEvent(analytics, 'page_view');

app.mount('#app');
